// src/components/resources/ResourcesEmptyState.js
// Empty state when no results match filters

import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SearchX, RotateCcw } from 'lucide-react';
import './styles/resources-empty-state.css';

const ResourcesEmptyState = ({ onClearFilters }) => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="resources-empty">
      <motion.div
        className="resources-empty__container"
        initial={prefersReducedMotion ? {} : { opacity: 0, y: 20 }}
        animate={prefersReducedMotion ? {} : { opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="resources-empty__icon">
          <SearchX size={48} strokeWidth={1.5} />
        </div>

        <h3 className="resources-empty__title">No results found</h3>

        <p className="resources-empty__text">
          We couldn't find any resources matching your current filters.
          Try adjusting your search or clearing filters to see more content.
        </p>

        <button className="resources-empty__button" onClick={onClearFilters}>
          <RotateCcw size={16} />
          <span>Clear all filters</span>
        </button>
      </motion.div>
    </section>
  );
};

export default ResourcesEmptyState;
